<template>
  <div>
    <LineChart :height="300" :chartdata="chartdata" :max="this.max" />
  </div>
</template>

<script>
import Chart from "chart.js";
import LineChart from "../chart/generic/lineChart.vue";
import moment from "moment";

Chart.defaults.global.layout.padding = 0;
Chart.defaults.global.title.display = true;
Chart.defaults.global.title.fontSize = 14;
Chart.defaults.global.title.fontFamily =
  '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif';
Chart.defaults.global.defaultFontFamily =
  '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif';

Chart.defaults.global.tooltips.bodyFontFamily =
  '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif';
Chart.defaults.global.tooltips.xPadding = 6;
Chart.defaults.global.tooltips.yPadding = 6;
Chart.defaults.global.tooltips.cornerRadius = 0;
Chart.defaults.global.tooltips.caretSize = 6;
Chart.defaults.global.tooltips.displayColors = false;
Chart.defaults.global.tooltips.backgroundColor = "#333";

// Moment JS em PT
moment.locale("pt", {
  months: "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
    "_"
  ),
  monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split("_"),
  weekdays: "domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado".split(
    "_"
  ),
  weekdaysShort: "dom_seg_ter_qua_qui_sex_sáb".split("_"),
  weekdaysMin: "dom_2ª_3ª_4ª_5ª_6ª_sáb".split("_"),
  longDateFormat: {
    LT: "HH:mm",
    L: "DD/MM/YYYY",
    LL: "D [de] MMMM [de] YYYY",
    LLL: "D [de] MMMM [de] YYYY [às] LT",
    LLLL: "dddd, D [de] MMMM [de] YYYY [às] LT",
  },
  calendar: {
    sameDay: "[Hoje às] LT",
    nextDay: "[Amanhã às] LT",
    nextWeek: "dddd [às] LT",
    lastDay: "[Ontem às] LT",
    lastWeek: function() {
      return this.day() === 0 || this.day() === 6
        ? "[Último] dddd [às] LT" // Saturday + Sunday
        : "[Última] dddd [às] LT"; // Monday - Friday
    },
    sameElse: "L",
  },
  relativeTime: {
    future: "em %s",
    past: "%s",
    s: "hoje",
    m: "um minuto",
    mm: "%d minutos",
    h: "uma hora",
    hh: "algumas horas",
    d: "há um dia",
    dd: "há %d dias",
    M: "um mês",
    MM: "%d meses",
    y: "um ano",
    yy: "%d anos",
  },
  ordinal: "%dº",
});

export default {
  name: "MainChart",
  props: ["dates", "data", "name", "max", "dataScatter"],
  components: { LineChart },
  data() {
    return {
      chartdata: {
        labels: this.dates,
        datasets: [
          {
            label: this.name,
            borderColor: "#ed1c24",
            pointHoverBackgroundColor: "#ed1c24",
            pointHoverRadius: 5,
            borderWidth: 3,
            pointRadius: 0,
            pointHitRadius: 10,
            fill: false,
            data: this.data,
          },
          {
            label: "valor real",
            backgroundColor: "#fbb67c",
            pointRadius: 2,
            pointHitRadius: -1,
            pointHoverRadius: 2,
            data: this.dataScatter,
            type: "scatter",
          },
        ],
      },
    };
  },
};
</script>

<style></style>
